import { render, staticRenderFns } from "./BannerAlert.vue?vue&type=template&id=4d72922a&scoped=true"
import script from "./BannerAlert.vue?vue&type=script&lang=js"
export * from "./BannerAlert.vue?vue&type=script&lang=js"
import style0 from "./BannerAlert.vue?vue&type=style&index=0&id=4d72922a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72922a",
  null
  
)

export default component.exports